import { Icon, List, ListItem, ListIcon, Divider } from '@chakra-ui/react'
import { MdPeople, MdTimer, MdLocalPhone, MdPlace, MdCallMade, MdNearMe, MdMovie } from 'react-icons/md'
import { dropFirstLetterZero, trackEvent } from 'utils';

const transformDate = dateInNumber => {
  const dateStrArr = dateInNumber.toString().split('');

  const year = dateStrArr[0] + dateStrArr[1] + dateStrArr[2] + dateStrArr[3];
  const month = dateStrArr[4] + dateStrArr[5];
  const day = dateStrArr[6] + dateStrArr[7];

  return `${year}-${month}-${day}`;
}

const GameBasicInfo = props => {
  const { 
    minPeople, 
    maxPeople, 
    duration, 
    storeAdd, 
    outdoorGameAddress,
    googleMapsUrl,
    isGameOver, 
    storeTel, 
    startDate,
    endDate,
  } = props;

  const displayAddress = storeAdd || outdoorGameAddress || "";
  const startDateStr = startDate ? transformDate(startDate) : null;
  const endDateStr = endDate ? transformDate(endDate) : null;

  // const handleExpandToggle = () => {
  //   setIsExpanded(!isExpanded);

  //   trackEvent({
  //     category: 'GameBasicInfo_toggle--GamePage',
  //     action: 'Click',
  //     label: title
  //   })
  // };

  return (
    <div className='mb-6 lg:mb-8'>
      <h4 className='mb-2 pl-2 text-lg leading-none font-bold border-l-4 border-primary'>
        基本資訊
      </h4>
      <Divider />

      <List pl={4} spacing={1} className='py-2 bg-white rounded-sm shadow-sm'>
        {(minPeople > 0 && maxPeople > 0) && (
          <ListItem>
            <ListIcon as={MdPeople} color='primary.500' />
            <span className='text-sm lg:text-base font-medium'>
              {minPeople} - {maxPeople} 人
            </span>
          </ListItem>
        )}

        {duration.length > 0 && (
          <ListItem>
            <ListIcon as={MdTimer} color='primary.500' />
            <span className='text-sm lg:text-base font-medium'>
              {dropFirstLetterZero(duration)}
            </span>
          </ListItem>
        )}

        {!isGameOver && displayAddress && (
          <ListItem>
            <ListIcon as={MdPlace} color='primary.500' />
            <a 
              href={googleMapsUrl || `https://www.google.com/maps/search/?api=1&query=${displayAddress}`} 
              target="_blank"
              className='text-sm lg:text-base hover:text-secondary' 
            >
              {displayAddress}
            </a>
          </ListItem>
        )}

        {!isGameOver && storeTel.length > 0 && (
          <ListItem>
            <ListIcon as={MdLocalPhone} color='primary.500' />
              <a 
                href={`tel:${storeTel}`} 
                className='text-sm lg:text-base hover:text-secondary' 
                onClick={() => {}}
              >
                {storeTel}
            </a>
          </ListItem>
        )}

        {(startDateStr || endDateStr || isGameOver) && (
          <ListItem>
            <ListIcon as={MdMovie} color='primary.500' />
            <span className='text-sm lg:text-base'>
              開幕日：{startDateStr || "調查中"}{(endDateStr || isGameOver) && (`｜謝幕日：${endDateStr || "調查中"}`)}
            </span>
          </ListItem>
        )}
      </List>
    </div>
  )
}

export default GameBasicInfo;